module.exports = __webpack_public_path__ + "img/program-avatar.1371f110.jpg";